import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'

import SwapProductAlert from '~/components/common/dialog/swapProduct/shared/SwapProductAlert'
import SwapProductDetails from '~/components/common/dialog/swapProduct/shared/SwapProductDetails'
import { convertSearchOrderToPrescription } from '~/components/common/dialog/swapProduct/utils'
import { getSwapProductTrackingData } from '~/constants/swapProductAnalytics'
import type { Order, Prescription } from '~/types'
import { trackEvent, TrackingEvent } from '~/utils/trackingProvider'

import SwapRxSearch from './search/SwapRxSearch'
import { SwapProductDialogSteps } from './types'

import styles from './SwapProductStep.module.scss'

interface SwapProductStepProps {
  onBack?: () => void
  onProceed?: (prescription: Prescription) => void
  prescription: Prescription
  showAlert: boolean
}

const SwapProductStep = ({
  showAlert,
  onBack,
  onProceed,
  prescription,
}: SwapProductStepProps) => {
  const changeType = 'product'
  const { t } = useTranslation(['Dialogs', 'Common'])
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null)

  const handleProceed = (order: Order) => {
    trackEvent(
      TrackingEvent.SWAP_PRODUCT_SEARCH_SELECT_PRODUCT,
      getSwapProductTrackingData(
        'SWAP_PRODUCT_SEARCH_SELECT_PRODUCT',
        prescription,
      ),
    )

    // Convert search Order to Prescription with base prescription data
    const newPrescription = convertSearchOrderToPrescription(
      order,
      prescription,
    )
    onProceed?.(newPrescription)
  }

  return (
    <div>
      {showAlert && <SwapProductAlert changeType={changeType} />}
      <SwapProductDetails
        prescription={prescription}
        step={SwapProductDialogSteps.CHANGE_PRODUCT}
      />
      <div className={styles.container}>
        <div className={styles.searchSection}>
          <h1>{t('SWAP_PRODUCT_DIALOG.RX_SEARCH')}</h1>
          <SwapRxSearch
            clientId={prescription.clientId}
            patientId={prescription.patientId}
            selectedOrder={selectedOrder}
            setSelectedOrder={setSelectedOrder}
          />
        </div>
      </div>
      {onProceed && (
        <div className={styles.footer}>
          <KibButtonNew
            disabled={selectedOrder === null}
            onClick={() => selectedOrder && handleProceed(selectedOrder)}
          >
            {t('SWAP_PRODUCT_DIALOG.CONTINUE_TO_PRESCRIPTION')}
          </KibButtonNew>
          {onBack && (
            <KibButtonNew emphasis="secondary" onClick={onBack}>
              {t('Common:BACK_ACTION')}
            </KibButtonNew>
          )}
        </div>
      )}
    </div>
  )
}

export default SwapProductStep
